import React, { useEffect, useState, useContext } from 'react';
import './GHGEmissions.scss';
import { withTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import DownloadImg from "../../../images/file_5520239.png";
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import GHGEmissionService from '../../../core/service/GHGEmissionService';
import useHasPermission from '../../../core/hooks/useHasPermission';

const DownloadTemplate = ({ t, gotoNext }) => {

    const [viewLoader, setViewLoader] = useState(false);
    const { setLoaderDisplay } = useContext(LoaderContext);
    const { hasDataCollectionUpdatePermission } = useHasPermission();

    const templateDownload = () => {
        setLoaderDisplay(true);
        GHGEmissionService.getTemplateFile()
            .then((response) => {
                setLoaderDisplay(false);
                let blob = new Blob([response.data], { type: 'application/octet-stream' });
                const fileURL = window.URL.createObjectURL(blob);
                let link = document.createElement('a');
                link.href = fileURL;
                link.download = `GHG-Template.xlsx`;
                link.click();
                link.remove();
            })
            .catch((error) => {
                setLoaderDisplay(false);
                toast.error(error.message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            });
    }

    const gotoNextPage = () => {
        gotoNext('import');
    }

    return (
        <div>
            <div className='Customize_templateView'>
                <div className='Customize_templateView_inner'>
                    <img className='CT_DownloadImg' src={DownloadImg} />
                    <h5>{t("ClickDownloadGetTemplate.label")}</h5>
                    
                    <div className='text-center p-2'>
                        {/* <Button variant='secondary' className='px-3 me-2'>Back</Button> */}
                        <Button variant='primary' className='px-3' onClick={() => templateDownload()}>{t("Download.label")}</Button>&nbsp;&nbsp;
                        <Button variant='secondary' className='px-3' hidden={!hasDataCollectionUpdatePermission()} onClick={() => gotoNextPage()}>{t("Next.label")}</Button>
                    </div>
                </div>
                {
                    viewLoader &&
                    <div className='Template_generated'>
                        <div className='spinner-8 '></div>
                        {t("TemplatGeneratedFilters.label")}
                    </div>
                }
            </div>
        </div>
    );


};

export default withTranslation()(DownloadTemplate);